module.exports = __webpack_public_path__ + "img/ids-logs-event-details.dc7b4f69.png";